/* ============================================
   COCO DE COCO Custom Wishlist - JavaScript
   localStorage-based wishlist with heart toggle
   ============================================ */

(function () {
  'use strict';

  const STORAGE_KEY = 'coco_wishlist';

  // ── Storage helpers ──────────────────────────
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function isWishlisted(id) {
    return getWishlist().includes(String(id));
  }

  function toggleWishlist(id) {
    const list = getWishlist();
    const sid  = String(id);
    const idx  = list.indexOf(sid);
    if (idx === -1) {
      list.push(sid);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return idx === -1; // true = now wishlisted
  }

  // ── Heart SVG ────────────────────────────────
  function heartSVG() {
    return `<svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round"
              xmlns="http://www.w3.org/2000/svg">
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06
               a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78
               1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    </svg>`;
  }

  // ── Create a heart button ─────────────────────
  function createBtn(productId) {
    const btn = document.createElement('button');
    btn.className        = 'coco-wishlist-btn';
    btn.setAttribute('aria-label', 'Add to wishlist');
    btn.setAttribute('data-product-id', productId);
    btn.innerHTML        = heartSVG();
    btn.type             = 'button';

    if (isWishlisted(productId)) {
      btn.classList.add('is-wishlisted');
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const wishlisted = toggleWishlist(productId);
      // Update all buttons for the same product on the page
      document.querySelectorAll(`.coco-wishlist-btn[data-product-id="${productId}"]`).forEach(b => {
        b.classList.toggle('is-wishlisted', wishlisted);
        // Pop animation
        b.classList.remove('pop');
        void b.offsetWidth; // reflow
        b.classList.add('pop');
        b.addEventListener('animationend', () => b.classList.remove('pop'), { once: true });
      });
    });

    return btn;
  }

  // ── Inject buttons into product cards ────────
  function injectCardButtons() {
    document.querySelectorAll('.card-wrapper[data-product-id]').forEach(card => {
      if (card.querySelector('.coco-wishlist-btn')) return;

      const productId = card.dataset.productId;
      if (!productId) return;

      // card__inner is already position:relative in Dawn theme
      const target = card.querySelector('.card__inner');
      if (!target) return;

      target.appendChild(createBtn(productId));
    });
  }

  // ── Inject button into product page gallery ───
  function injectProductPageButton() {
    const wrapper = document.querySelector('.product__media-wrapper[data-product-id]');
    if (!wrapper) return;
    if (wrapper.querySelector('.coco-wishlist-btn')) return;

    const productId = wrapper.dataset.productId;
    if (!productId) return;

    // Find the first visible media item
    const firstMedia = wrapper.querySelector('.product__media, .global-media-settings, .media');
    const target = firstMedia || wrapper;
    if (target.style) target.style.position = 'relative';
    target.appendChild(createBtn(productId));
  }

  // ── Render Dropdown UI ───────────────────────
  async function renderDropdownWishlist() {
    const grid = document.getElementById('WishlistDropdownGrid');
    const headerCount = document.getElementById('WishlistCountHeader');
    if (!grid) return;
    
    const list = getWishlist();
    if (list.length === 0) {
      grid.innerHTML = '<span class="wishlist-empty-msg">Your wishlist is empty</span>';
      if (headerCount) headerCount.innerText = '';
      return;
    }
    
    if (headerCount) headerCount.innerText = `(${list.length})`;
    grid.innerHTML = '<span class="wishlist-empty-msg">Loading...</span>';
    
    try {
        let html = '';
        for (const id of list) {
            // Shopify storefront search by exact Product ID
            const root = window.Shopify.routes ? window.Shopify.routes.root : '/';
            const res = await fetch(`${root}search/suggest.json?type=product&q=id:${id}`);
            const data = await res.json();
            const products = data.resources?.results?.products || [];
            
            if (products.length > 0) {
                const p = products[0];
                html += `
                <div class="wishlist-item-mini" data-id="${id}">
                   <img src="${p.image}" alt="${p.title}" />
                   <div class="wishlist-item-mini-info">
                      <a href="${p.url}" class="wishlist-item-mini-title">${p.title}</a>
                      <span class="wishlist-item-mini-price">${p.price}</span>
                   </div>
                   <button class="wishlist-item-mini-remove" data-remove-id="${id}" aria-label="Remove">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                         <line x1="18" y1="6" x2="6" y2="18"></line>
                         <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                   </button>
                </div>
                `;
            }
        }
        
        grid.innerHTML = html || '<span class="wishlist-empty-msg">Products not found.</span>';
        
        // Attach remove events
        grid.querySelectorAll('.wishlist-item-mini-remove').forEach(btn => {
           btn.addEventListener('click', function(e) {
              e.preventDefault();
              const removeId = this.getAttribute('data-remove-id');
              const currentList = getWishlist();
              const idx = currentList.indexOf(removeId);
              if (idx > -1) {
                  currentList.splice(idx, 1);
                  saveWishlist(currentList);
                  renderDropdownWishlist();
                  
                  // Update card buttons
                  document.querySelectorAll(`.coco-wishlist-btn[data-product-id="${removeId}"]`).forEach(b => {
                      b.classList.remove('is-wishlisted');
                  });
              }
           });
        });
        
    } catch (err) {
        console.error('Error fetching wishlist', err);
        grid.innerHTML = '<span class="wishlist-empty-msg">Error loading wishlist.</span>';
    }
  }

  // ── Run ──────────────────────────────────────
  function init() {
    injectCardButtons();
    injectProductPageButton();
    renderDropdownWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Bind to details toggle so it refreshes only when opened
  const accountDetails = document.getElementById('Details-Account-Header');
  if (accountDetails) {
     accountDetails.addEventListener('toggle', function() {
        if (this.open) renderDropdownWishlist();
     });
  }

  // Re-run if new cards appear (e.g. infinite scroll / section renders)
  const observer = new MutationObserver(() => {
    injectCardButtons();
    injectProductPageButton();
  });
  observer.observe(document.body, { childList: true, subtree: true });


})();
